import BettingCenterViewImpl from './betting-center-view.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import ViewTypes from 'modules/betting-center/view-types.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * BettingCenterView renders a switchable set of tabs set that includes Betslip and Open bets.
 *
 * @class BettingCenterView
 * @name view
 * @memberof Mojito.Modules.BettingCenter
 */

/**
 * `BettingCenterView` prop types.
 *
 * @property {number} [betslipItemsCount = 0] - The number of items in the betslip.
 * @property {number} [openBetsCount = 0] - The number of open bets.
 * @property {Mojito.Modules.BettingCenter.viewTypes} [selectedTab = BETSLIP] - The currently selected tab.
 *
 * @memberof Mojito.Modules.BettingCenter.view
 */
const propTypes = {
    betslipItemsCount: PropTypes.number,
    openBetsCount: PropTypes.number,
    selectedTab: PropTypes.oneOf(Object.values(ViewTypes)),
};

const defaultProps = {
    openBetsCount: 0,
    betslipItemsCount: 0,
    selectedTab: ViewTypes.BETSLIP,
};

export default UIView('BettingCenterView', BettingCenterViewImpl, propTypes, defaultProps);
